// The demo account's name as the account switch lists it (T-283 / T-284, D-383; one home since T-286).
//
// Both apps need the one row they cannot derive before a client exists — the sample account's entry in the
// account switch — and neither may import `@sl/core/demo` from its shell (the demo server is a lazy chunk,
// ARCH §8.1). So the name lives here, on the root entry, beside the API client: the dataset's own
// `account.name` ("Juniper Home Goods", `data/demo/juniper.v1.json`) with the switch's "(demo)" suffix.
// `demoAccount.test.ts` holds the two together.

/** The dataset's `account.name`. */
export const DEMO_ACCOUNT_DATASET_NAME = 'Juniper Home Goods';

/** What the account switch shows for the sample account, on both builds. */
export const DEMO_ACCOUNT_NAME = `${DEMO_ACCOUNT_DATASET_NAME} (demo)`;
